import React, { Component } from "react";
import flatpickr from "flatpickr";
import Button from "../../components/bases/button/button";
import "flatpickr/dist/flatpickr.min.css";
import { French } from "flatpickr/dist/l10n/fr.js"; // Import French locale
import  back  from "./assets/back.png"

class DatePickerBox extends React.Component
{
    
    constructor(props)
    {
        super(props);
        this.flatpickrInstance = null;



        var date = this.parseFrenchDateSafe(this.props.value);
        if ((this.props.canbeempty) && (this.props.value==="")) date="";
        


        this.state =
        {
            value: this.props.value,
            errmsg: this.props.errmsg,
            selectedDate: date,
        }

        this.datepickerRef = React.createRef();

        this.handleButtonClear = this.handleButtonClear.bind(this)

    }

    isValidDate(day, month, year) 
    {
        const date = new Date(year, month - 1, day);
        return (
          date.getDate() === day &&
          date.getMonth() === month - 1 &&
          date.getFullYear() === year
        );
     }
      
    parseFrenchDateSafe(dateString) 
    {
        const [year, month, day] = dateString.split("/").map(Number);
        if (this.isValidDate(day, month, year)) {
          return new Date(year, month - 1, day);
        }
        return new Date();
      }


    getFormatedDate(dateString)
    {
        var date = this.parseFrenchDateSafe(dateString);
        const year = date.getFullYear(); // Année AAAA
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
        const day = String(date.getDate()).padStart(2, '0'); // Jour (01-31)
      
        return `${day}/${month}/${year}`;


    }

    setErrorMsg(msg)
    {
        this.setState({errmsg:msg});
    }


    componentDidMount()
    {

        if (!this.props.readOnly)
        {
            this.flatpickrInstance = flatpickr(this.datepickerRef.current, {
                appendTo: document.body,
                dateFormat: "d/m/Y",
                static: true,
                locale: French,
                defaultDate: this.state.selectedDate,
                onChange: this.handleDateChange, // Callback when the date is selected
            });        
        }
    }

    componentWillUnmount() {
        if (!this.props.readOnly)
        {
            if (this.flatpickrInstance) {
            this.flatpickrInstance.destroy();
            }
        }
      }

    handleDateChange = (selectedDates) => {

        var date = selectedDates[0];

        const year = date.getFullYear(); // Année AAAA
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
        const day = String(date.getDate()).padStart(2, '0'); // Jour (01-31)
      
        const value  =  `${year}/${month}/${day}`;


        this.setState({ value: value, selectedDate: selectedDates[0] });
        
      };

    componentDidUpdate()
    {
        if (!this.props.readOnly) this.props.onChange();
    }

    setValue(text)
    {
        if (text != this.state.value)
        {   
            this.setState({ value: text, selectedDate: this.parseFrenchDateSafe(text) });
        }
            
    }


    getValue()
    {
        return this.state.value.trim();


    }

    handleButtonClear()
    {

        this.setState({value:"", selectedDate:""});
    }


    render()
    {

        if (this.props.readOnly)
        {
            var date = this.getFormatedDate(this.state.value)
            return(
                    <div className = "dialog-Input-Title">
                        {this.props.title}{msg}
                    
                    <input className="dialog-Input-Datas" autoFocus={this.props.autoFocus}
                            type="text"
                            ref  = {this.datepickerRef}
                            readOnly={true}
                            disabled={false}
                            value = {date}
                            style = {{width: this.props.width, textAlign: "center"}}
                             />
                    </div>        
                )

            }

        var button = (<></>);
        if (this.props.canbeempty)
        {
          button = (
            <Button 
            button={true}
            tooltip={null}
            image={back}
            disable={this.state.value==""}
            onClick={this.handleButtonClear}
            width={16}
            height={16}/>)
          }
        
        var msg="";
        if (this.state.errmsg != "")
        {
            msg=(
                <span style={{borderRadius:"3px",marginLeft:"12px",color:"white", borderStyle:"solid", borderColor:"red", borderWidth:"1px"}}
                    >
                &nbsp;&nbsp;{this.state.errmsg}&nbsp;&nbsp;
                </span>
            )
        }

        const { selectedDate } = this.state.selectedDate;
        
        var date = this.getFormatedDate(this.state.value);
        if ((this.props.canbeempty) && (this.state.value===""))
            date = "";

        return (<>
            <div className = "dialog-Input-Title">
                {this.props.title}{msg}
            
            <input className="dialog-Input-Datas" autoFocus={this.props.autoFocus}
                    type="text"
                    ref  = {this.datepickerRef}
                    value={date}
                    readOnly={this.props.readOnly}
                    disabled={this.props.disabled}
                    onChange={e => this.setState({value:e.target.value})}
                    style = {{width: this.props.width, textAlign: "center"}}
                    required /> {button}

            {selectedDate && (
                    <p>Selected Date: {selectedDate.toLocaleDateString()}</p>
        )}  
            </div>                  
            
        </>);
    }

}
DatePickerBox.defaultProps = 
{
    align: "left",
    autoFocus: false,
    readOnly: false,
    disabled: false,
    errmsg: "",
    canbeempty: false,
}

export default DatePickerBox